import React, {useState} from 'react'
import styled from "@emotion/styled/macro"
import { Link } from 'gatsby'
import SvgRightArrowMenu from '../images/SVGs/RightArrowMenu'
import SvgDownArrowMenu from '../images/SVGs/DownArrowMenu'
import { theme, device } from './Theme'

const ThirdLevel = (props) =>{
    const thirdLevel = props.thirdLevel
    return(
<li key={'thirdLevel'+thirdLevel.index}>
  <div className="linkArrowHolder">
  <a href={thirdLevel.path}>
       {thirdLevel.label}
       </a>
  </div>
       
             </li>
    )
}
const SecondLevel = (props) =>{
    const [thirdLevelVisible, setThirdLevelVisible] = useState(true);
  const toggleThirdLevelVisible = (key) => {
    setThirdLevelVisible((prev) =>
      Boolean(!prev[key]) ? { ...prev, [key]: true } : { ...prev, [key]: false }
    );
  };


  const item = props.item
    return(
        <ul className="secondLevel">
{item.secondLevel.map(secondLevel =>{
    return(
        <li>
            <div className="linkArrowHolder">
            <a href={secondLevel.path}>
       {secondLevel.label}
       </a>
       {secondLevel.thirdLevel !== 0 &&
       <button 
       className="rightArrow"
       onClick={() => toggleThirdLevelVisible(secondLevel.id)}
       >
         
{thirdLevelVisible[secondLevel.id] ? 
  <SvgDownArrowMenu />
  :
<SvgRightArrowMenu />
}
         
       </button>
           }
            </div>
            {thirdLevelVisible[secondLevel.id] === true &&
       secondLevel.thirdLevel !== 0 &&
       <ul className="thirdLevel">
         {secondLevel.thirdLevel.map(thirdLevel =>{
           return(
             <ThirdLevel thirdLevel={thirdLevel} />
           )
         })}
       </ul>
       }
        </li>
    )
})}
        </ul>
    )
}
const MainMenu = (props) =>{
    const [secondLevelVisible, setSecondLevelVisible] = useState(true);
      const toggleSecondLevelVisible = (key) => {
        setSecondLevelVisible((prev) =>
          Boolean(!prev[key]) ? { ...prev, [key]: true } : { ...prev, [key]: false }
        );
      };
    const item = props.item
    return(
      <li className={props.isSidebar === true ? `sidebar`+item.className : item.className}>
                          <div className={props.isSidebar === true ? `linkArrowHolder sidebar` : `linkArrowHolder`}>
                              <a href={item.path}>
                                  {props.isSidebar === true &&
                                  <div className='sidebarMenuIcons' dangerouslySetInnerHTML={{__html: item.icon}}  />
                                  }
                                  

  <p>{item.label}</p>
                              </a>
                              {item.secondLevel !== 0 &&
                              <button 
                              className="rightArrow"
                              onClick={() => toggleSecondLevelVisible(item.id)}
                              >
           
                              {secondLevelVisible[item.id] ? 
                                <SvgDownArrowMenu />
                                :
                              <SvgRightArrowMenu />
                              }
                                       
                                     </button>
                              }
                          </div>
                          {secondLevelVisible[item.id] === true &&
                          item.secondLevel !== 0 &&
                          <SecondLevel item={item}/>
                          }
                      </li>
    )
  }
const MobileAndSidebarMenuItems = (props) =>{
    const MainMenuContainer = styled.ul`
    margin: 0.5rem 0 0 0;

    @media ${device.lg}{
        column-count: 1 !important;
    }
 
  .linkArrowHolder{
  display: flex;
  text-transform: uppercase;
  font-size: 1.1875rem;
  font-weight: 700;
  border-bottom: 1px solid ${theme.colors.gray};

  a{
      display: flex;
      gap: 1.6875rem;
      align-items: center;
    color: ${theme.colors.dark};
    width: 100%;
    &:hover, &:active{
      color: ${theme.colors.secondary};
    }
  }
  button{
    appearance: none;
    border: none;
    background-color: transparent;

    &:hover, &:active{
      cursor: pointer;
    }
  }
}
.linkArrowHolder.sidebar{
padding: 0 1.9375rem;
}
.rightArrow{
  padding: 0 0.75rem 0 0;
}
.secondLevel{
    column-count: 1;
  background-color: ${theme.colors.secondary};
  a{
      display: inline-block;
      padding: 1.25rem 0.75rem;
    &:hover, &:active{
      color: ${theme.colors.primary};
    }
  }
}
.thirdLevel {
    column-count: 1;
    li:first-of-type{
margin: 0;
    }
  .linkArrowHolder{
    background-color: ${theme.colors.primary};
  
    a{
      color: ${theme.colors.light};
      &:hover, &:active{
        color: ${theme.colors.secondary};
      }
    }
  }
  }
  li{
      background-image: none;
      height: auto;
      padding-left: 0;
      margin: 0;
  }
  .sidebarwhyBillFrusco{
      display: none;
  }
  .sidebarMenuIcons{
      min-width: 41px;
  }
  p{
  margin: 1.9375rem 0;
}
    `
    return(
        <MainMenuContainer>
            {props.mainMenuItems.map(item =>{
                return(
                    <MainMenu item={item} isSidebar={props.isSidebar} />
                )
            })}
            </MainMenuContainer>
    )
}
export {MobileAndSidebarMenuItems}